<template>
  <div class="level">
    <div class="container">
      <!-- Content here -->
      <br />

      <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <a class="navbar-brand" href="#">代買幫-我的會員等級</a>
      </nav>

      <br />
      <div class="card">
        <div class="card-body">
          <h5>我的累積金額</h5>
          <h4>${{ displayViews.amount }}</h4>
          <div id="chart">
            <apexchart
              type="radialBar"
              height="350"
              :options="chartOptions"
              :series="series"
            />
          </div>
          <h5>我的等級</h5>
          <div v-if="displayViews.level == 0">
            <h5>一般會員</h5>
          </div>
          <div v-if="displayViews.level == 1">
            <h5>白銀會員</h5>
          </div>
          <div v-if="displayViews.level == 2">
            <h5>黃金會員</h5>
          </div>
          <br />
          <div v-if="displayViews.nextLevel == 0">
            <h5>再消費滿{{ displayViews.distance }}元 立即升級為一般會員</h5>
          </div>
          <div v-if="displayViews.nextLevel == 1">
            <h5>再消費滿{{ displayViews.distance }}元 立即升級為白銀會員</h5>
          </div>
          <div v-if="displayViews.nextLevel == 2">
            <h5>再消費滿{{ displayViews.distance }}元 立即升級為黃金會員</h5>
          </div>
          <br />
          <div class="alert alert-success" role="alert">
            <h4 class="alert-heading">代買幫會員分級優待項目：</h4>
            <p>一般會員：可享代買幫匯率</p>
            <p>
              白銀會員：可享代買幫匯率
              <b>-0.03</b>
            </p>
            <p>
              黃金會員：可享代買幫匯率
              <b>-0.07</b>
            </p>
            <hr />
            <h4 class="alert-heading">代買幫會員升級資格：</h4>
            <p>白銀會員：今日起，90日內消費累積金額達2萬元台幣，自動升級</p>
            <p>黃金會員：今日起，90日內消費累積金額達5萬元台幣，自動升級</p>
            <p>
              代買幫提供商業報關，簡易報關手續費150元，正式報關手續費500元，運費最低以10公斤計算(只有空運支援)，每次需額外繳交商品價值20%為關稅押金，多退少補。
            </p>
          </div>
        </div>
      </div>
    </div>
    <loading
      loader="bars"
      :active.sync="isLoading"
      :can-cancel="true"
      :is-full-page="true"
    ></loading>
    <v-dialog />
  </div>
</template>
<style type="text/css"></style>
<script>
import VueLoading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import VueApexCharts from 'vue-apexcharts'
import axios from 'axios'
export default {
  name: 'level',
  components: {
    loading: VueLoading,
    apexchart: VueApexCharts,
  },
  data: function () {
    return {
      apiUrl: process.env.VUE_APP_API_URL,
      isLoading: false,
      userId: '',
      userImage: '',
      userName: '',
      checkUnChatbotSigninStatus: false,
      displayViews: '',
      walletInfo: {},
      series: [0],
      chartOptions: {
        plotOptions: {
          radialBar: {
            hollow: {
              size: '60%',
            },
          },
        },
        labels: ['累積金額'],
      },
    }
  },
  watch: {},
  methods: {
    getUserLevel: function (userId) {
      const vm = this
      vm.isLoading = true
      vm.$toast.open({
        message: '讀取中!',
        type: 'success',
      })
      axios
        .post(vm.apiUrl + 'GetUserLevel', {
          userId: userId,
        })
        .then(function (response) {
          if (response.data.length == 0) {
            // alert("系統錯誤請稍後再試");
            vm.$toast.open({
              message: '讀取失敗!請聯絡客服!',
              type: 'error',
            })
          } else {
            vm.displayViews = response.data
            vm.$set(vm.series, 0, vm.displayViews.percent)
            vm.$toast.open({
              message: '讀取成功!',
              type: 'success',
            })
          }
          vm.isLoading = false
          document.body.scrollTop = 0
          document.documentElement.scrollTop = 0
          // console.log(response.data);
        })
        .catch(function (error) {
          alert(error)
          // console.log(error);
        })
    },
    checkUnChatbotSignin: function () {
      const vm = this
      if (!localStorage.userId) {
        vm.$modal.show('dialog', {
          title: '🙋您尚未登入FB會員',
          text: '請先登入才能使用此服務喔⚡',
          buttons: [
            {
              title: '關閉',
            },
            {
              title: '👉用FB登入',
              handler: () => {
                window.location = 'https://m.me/2266831083395361'
              },
            },
          ],
        })

        vm.checkUnChatbotSigninStatus = true
        return true
      } else {
        vm.userName = localStorage.userName
        vm.checkUnChatbotSigninStatus = false
        return false
      }
    },
  },
  mounted() {
    const vm = this
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
    try {
      if (vm.$route.query.userId) {
        localStorage.userId = decodeURI(vm.$route.query.userId)
      }
      vm.checkUnChatbotSignin()
      vm.getUserLevel(localStorage.userId)
    } catch (e) {
      // console.info(e);
      alert(e)
    }
  },
}
</script>
